// removed by extract-text-webpack-plugin
module.exports = {"about":"About__about___3LKT7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/About/About.scss
// module id = 920
// module chunks = 0